import React from 'react';
import TextField from '@material-ui/core/TextField';
import { useForm, Controller } from 'react-hook-form';
import { EMAIL_REGEX } from '../../Constants';
import { SkywatchDialog } from '../PopUps/SkywatchDialog';
import FlexView from 'react-flexview/lib';
import NewButtonPopup from '../Core/Buttons/NewButtonPopup';
import { ElevatedCircle } from '../Core/ElevatedCircle';
import policymanagementApi from '../../api/policymanagement.api';
import { addDays, awaitWithLoading } from '../../services/utils';
import { EventEmitterService, EventKey } from '../../services/EventEmitterService';
import { PolicyManagementContextStore, ACTIONS } from '../../context/PolicyManagementContext';
import { Action } from '../../models/Action';
import AssignmentIcon from '@material-ui/icons/Assignment';
import { ActiveInsuranceModel } from '../../models/insurance-models/ActiveInsuranceModel';
import { RadioGroup, Radio, FormControlLabel,Select, MenuItem, Grid ,IconButton,InputAdornment} from '@material-ui/core';
import policmanagementImpersonationApi from '../../api/policmanagement.impersonation.api';
import { BlueGrayBox } from "../Core/BlueGrayBox";
import { DatePicker } from '@material-ui/pickers'
import { FirebaseService, FirebaseConfigKey } from '../../services/FirebaseService';
import EventIcon from '@material-ui/icons/Event';
import {ModificationApi} from "../../api/modification.api"
import NewFillButton from '../Core/NewFillButton'


export const ApproveRefundPopup = ({openApproveCancel,onClose,onApprove}) => {
  const { register, errors, getValues, triggerValidation, control } = useForm()
  const context = React.useContext(PolicyManagementContextStore)


  return (
      <SkywatchDialog
                open={openApproveCancel.open}
                maxWidth={'xs'}
                closeDialog={() => onClose()}
            >
                    <div>
                        <div className="textcenter">
                            {openApproveCancel.isNotRefund?
                            <div>You are about to add this customer a refund report of:{' '}</div>
                            :
                            <div>You are about to refund customer an amount of:{' '}</div>}
                            {FirebaseService.getValue(
                                FirebaseConfigKey.CURRENCY_SYMBOL
                            )}
                            {openApproveCancel.amount}
                            <br />
                            By clicking 'Approve' the refund will be submitted
                            {openApproveCancel.isNotRefund &&
                            <div><br/>Please note: No actual refund will be conducted on Stripe.</div>}
                        </div>
                        <NewFillButton onClick={onApprove}>
                            Approve
                        </NewFillButton>
                    </div>
            </SkywatchDialog>
  );
}